const DEVICEQUERRY = {
  xs: "@media screen and (min-width: 0px)",
  sm: "@media screen and (min-width: 576px)",
  md: "@media screen and (min-width: 768px)",
  lg: "@media screen and (min-width: 992px)",
  xl: "@media screen and (min-width: 1200px)"
};

export default DEVICEQUERRY;
